
import styles from './index.module.scss'
import Utils from '@utils/utils'
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Image, Popover } from 'antd'
import { IMAGE_TYPE, TYPETITLEMAP, CLOTH_COLOR_TYPE, VIDEO_ORIENTATION, GENERATE_MODE, POSE_FANTASY_MODE } from '@utils/CONST'
import Iconfont from '@utils/Iconfont';
import { LoadingOutlined } from '@ant-design/icons';

const ProjectDetailGroupsTitle = (props) => {
    const { item, imageType } = props;
    const mainTitle = (
        <span className={styles.mainTitle}>{
            (imageType == IMAGE_TYPE.MODEL && item.keepBkg) ?
                '只换模特' : (imageType == IMAGE_TYPE.MODEL && item.keepPose) ? '只换背景' :
                    (imageType == IMAGE_TYPE.CLOTH_RECOLOR && item.mode == CLOTH_COLOR_TYPE.CLOTH_RECOLOR) ? '自由换色' :
                        (imageType == IMAGE_TYPE.CLOTH_RECOLOR && item.mode == CLOTH_COLOR_TYPE.SIM_RECOLOR) ? '同款换色' :
                            TYPETITLEMAP[imageType]
        }</span>
    )

    const videoDesc = useMemo(() => {
        return item?.prompt || (imageType == IMAGE_TYPE.FUSION_WEAR ? <LoadingOutlined /> : null)
    }, [item, imageType])

    const videoTextRef = useRef(null)
    const [videoOverflow, setVideoOverflow] = useState(false)
    const [videoPopoverOpen, setVideoPopoverOpen] = useState(false)

    useEffect(() => {
        const el = videoTextRef.current
        if (!el) return
        setVideoOverflow(el.scrollHeight > el.clientHeight + 1)
    }, [videoDesc])

    const videoTitle = (
        <div className={styles.videoTitle}>
            <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.inputImage)} />
            <div className={styles.videoTextWrap}>
                <div className={styles.textOnlyWrap}>
                    <span ref={videoTextRef} className={styles.videoText}><span style={{ fontWeight: 'bold', color: '#000' }}>动作模仿</span> {videoDesc}</span>
                    {videoOverflow && (
                        <Popover
                            open={videoPopoverOpen}
                            onOpenChange={setVideoPopoverOpen}
                            trigger="hover"
                            placement="bottomRight"
                            content={<div className={styles.videoPopoverContent}>{videoDesc}</div>}
                        >
                            <span className={styles.viewAll}>查看全部</span>
                        </Popover>
                    )}
                </div>

                <p className={styles.detail}>
                    <span>{item?.createdTime}</span>
                    <span>{(item?.orientation === VIDEO_ORIENTATION.REF || !item?.orientation) ? '与参考视频一致': '与模特图一致'}</span>
                    <span>{(item?.mode === GENERATE_MODE.STD || !item?.mode) ? '标准模式' : '高品质模式'}</span>
                </p>
            </div>
        </div>
    )

    const videoTitle2 = (
        <div className={styles.videoTitle}>
            <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.inputImage)} />
            {item.imageTail && <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.imageTail)} />}
            <div className={styles.videoTextWrap}>
                <div className={styles.textOnlyWrap}>
                    <span ref={videoTextRef} className={styles.videoText}><span style={{ fontWeight: 'bold', color: '#000' }}>图生视频</span> {videoDesc}</span>
                    {videoOverflow && (
                        <Popover
                            open={videoPopoverOpen}
                            onOpenChange={setVideoPopoverOpen}
                            trigger="hover"
                            placement="bottomRight"
                            content={<div className={styles.videoPopoverContent}>{videoDesc}</div>}
                        >
                            <span className={styles.viewAll}>查看全部</span>
                        </Popover>
                    )}
                </div>

                <p className={styles.detail}>
                    <span>{item?.createdTime}</span>
                    <span>{item?.duration == 5 ? '5秒' : '10秒'}</span>
                    <span>{item?.mode === GENERATE_MODE.STD ? '标准模式' : '高品质模式'}</span>
                </p>
            </div>
        </div>
    )

    const fusionWearTitle = (
        <div className={styles.videoTitle}>
            {
                item?.matchImages?.map((img, index) => (
                    <Image className={styles.thumbnail} src={Utils.getImgThumbnail(img?.url)} />
                ))
            }
            {item?.modelImage?.url && <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.modelImage?.url)} />}
            <div className={styles.videoTextWrap}>
                <div className={styles.textOnlyWrap}>
                    <span ref={videoTextRef} className={styles.videoText}>{videoDesc}</span>
                    {videoOverflow && (
                        <Popover
                            open={videoPopoverOpen}
                            onOpenChange={setVideoPopoverOpen}
                            trigger="hover"
                            placement="bottomRight"
                            content={<div className={styles.videoPopoverContent}>{videoDesc}</div>}
                        >
                            <span className={styles.viewAll}>查看全部</span>
                        </Popover>
                    )}
                </div>

                <p className={styles.detail}>
                    <span>{item?.createdTime}</span>
                </p>
            </div>
        </div>
    )

    const personTitle = !item.keepPose &&
        <React.Fragment>
            <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.person?.url)} />
            <span className={styles.title}>
                {
                    item?.person?.custom ? "自定义模特" :
                        item?.person?.title?.split("-").pop()
                }
            </span>
        </React.Fragment>

    const bkgTitle = !item.keepBkg &&
        <React.Fragment>
            <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.background?.url)} />
            <span className={styles.title}>
                {
                    item?.background?.custom ? "自定义背景" :
                        item?.background?.title?.split("-").pop()
                }
            </span>
        </React.Fragment>

    const poseTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.pose?.url)} />
        <span className={styles.title}>
            {item?.pose?.custom ? "自定义参考图" : '参考图'}
        </span>
    </React.Fragment>

    const shoesTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.shoesRef?.url)} />
        <span className={styles.title}>
            {item?.shoesRef?.custom ? "自定义参考图" : '预设参考图'}
        </span>
    </React.Fragment>

    const reColorTitle = <React.Fragment>
        <span className={styles.colorBox} style={{ backgroundColor: item.color }} ></span>
        <span className={styles.title}>{item.color}</span>
    </React.Fragment>

    const simReColorTitle = <React.Fragment>
        {
            item.clothes?.split(',').map((url) => (
                <Image style={{ marginRight: 5 }} className={styles.thumbnail} src={Utils.getImgThumbnail(url)} />
            ))
        }
        <span className={styles.title}>衣服平铺图</span>
    </React.Fragment>

    const commidityTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.background?.url)} />
        <span className={styles.title}>
            {
                item?.background?.custom ? "自定义背景" :
                    item?.background?.title?.split("-").pop()
            }
        </span>
    </React.Fragment>

    const modelTitle = <React.Fragment>
        <Iconfont type={item?.mode == 'hq' ? "icon-hdOutlined" : "icon-stdOutlined"} className={styles.Icon} />
        <span className={styles.title}>
            {item?.mode == 'hq' ? "高品质模式" : item?.mode == 'std' ? "标准模式" : null}
        </span>
    </React.Fragment>

    const poseTryonTitle = (
        item.mode == POSE_FANTASY_MODE.REFERENCEMODE ?
            <React.Fragment>
                <span className={styles.title}>参考图模式</span>
                <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.poseRef?.url)} />
                <span className={styles.title}>
                    {
                        item?.poseRef?.custom ? "自定义参考图" :
                            '预设参考图'
                    }
                </span>
            </React.Fragment>
            : <div className={styles.videoTitle}>
                <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.inputImage)} />
                {item.imageTail && <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.imageTail)} />}
                <div className={styles.videoTextWrap}>
                    <div className={styles.textOnlyWrap}>
                        <span ref={videoTextRef} className={styles.videoText}>{videoDesc}</span>
                        {videoOverflow && (
                            <Popover
                                open={videoPopoverOpen}
                                onOpenChange={setVideoPopoverOpen}
                                trigger="hover"
                                placement="bottomRight"
                                content={<div className={styles.videoPopoverContent}>{videoDesc}</div>}
                            >
                                <span className={styles.viewAll}>查看全部</span>
                            </Popover>
                        )}
                    </div>

                    <p className={styles.detail}>
                        <span>{item?.createdTime}</span>
                        <span>自由模式</span>
                    </p>
                </div>
            </div>
    )

    const glassesTryonTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.glassesRef?.url)} />
        <span className={styles.title}>
            {
                item?.glassesRef?.custom ? "自定义参考图" : '预设参考图'
            }
        </span>
    </React.Fragment>

    const simTryonTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.poseRef?.url)} />
        <span className={styles.title}>
            {item?.poseRef?.custom ? "自定义参考图" : '预设参考图'}
        </span>
    </React.Fragment>

    const resolutionAlignTitle = <React.Fragment>
        <span className={styles.title}>
            {item?.resolutionAlign == 'bkg' ? "参考图比例" : item?.resolutionAlign == 'input' ? "上传图比例" : null}
        </span>
    </React.Fragment>

    return (
        <div className={styles.ProjectDetailGroupsTitle}>
            {
                imageType == IMAGE_TYPE.MODEL_VIDEO ? videoTitle :
                    imageType == IMAGE_TYPE.IMAGE_TO_VIDEO ? videoTitle2 :
                        imageType == IMAGE_TYPE.FUSION_WEAR ? fusionWearTitle :
                            mainTitle}
            {imageType == IMAGE_TYPE.CLOTHES && poseTitle}
            {(imageType == IMAGE_TYPE.CLOTHES || imageType == IMAGE_TYPE.MODEL) && personTitle}
            {(imageType == IMAGE_TYPE.CLOTHES || imageType == IMAGE_TYPE.MODEL) && bkgTitle}
            {imageType == IMAGE_TYPE.COMMODITYRECOLOR && reColorTitle}
            {imageType == IMAGE_TYPE.CLOTH_RECOLOR && (item.mode == CLOTH_COLOR_TYPE.CLOTH_RECOLOR ? reColorTitle : simReColorTitle)}
            {imageType == IMAGE_TYPE.SHOES && shoesTitle}
            {imageType == IMAGE_TYPE.COMMODITY && commidityTitle}
            {(imageType == IMAGE_TYPE.CLOTHES || imageType == IMAGE_TYPE.SHOES || imageType == IMAGE_TYPE.GRASS_PLANT) && modelTitle}
            {(imageType == IMAGE_TYPE.POSE_TRYON) && poseTryonTitle}
            {(imageType == IMAGE_TYPE.GLASSES_TRYON) && glassesTryonTitle}
            {(imageType == IMAGE_TYPE.SIM_TRYON) && simTryonTitle}
            {(imageType == IMAGE_TYPE.MODEL) && resolutionAlignTitle}
        </div>  
    )
}

export default ProjectDetailGroupsTitle